import React from "react";

const TickIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
        >
            <path
                d="M10.0003 2.16663C5.40033 2.16663 1.66699 5.89996 1.66699 10.5C1.66699 15.1 5.40033 18.8333 10.0003 18.8333C14.6003 18.8333 18.3337 15.1 18.3337 10.5C18.3337 5.89996 14.6003 2.16663 10.0003 2.16663ZM7.74199 14.075L4.75033 11.0833C4.42533 10.7583 4.42533 10.2333 4.75033 9.90829C5.07533 9.58329 5.60033 9.58329 5.92533 9.90829L8.33366 12.3083L14.067 6.57496C14.392 6.24996 14.917 6.24996 15.242 6.57496C15.567 6.89996 15.567 7.42496 15.242 7.74996L8.91699 14.075C8.60033 14.4 8.06699 14.4 7.74199 14.075Z"
                fill="white"
            />
        </svg>
    );
};

export default TickIcon;
